export const events = Object.freeze({
    STEP_SUBMITTED: 'step:submitted',
    STEP_LOADED: 'step:loaded',
    CONTENT_WILL_REMOVE: 'content:willRemove',
    CONTENT_UPDATED: 'content:updated',
    CHECKBOX_CLICKED: 'checkbox:clicked',
    INPUTS_CHANGED: 'inputs:changed'
});
